import NumberInput from './NumberInput'

export {
  NumberInput
}



// WEBPACK FOOTER //
// ./src/app/components/common/inputs/index.js